import {
  PrivacyLevel,
  type Listing,
  type RestrictedListing,
  type SearchListing,
  type SearchListingResult,
  type SearchRestrictedListing,
  type SearchUserAccountExclusiveListing,
  type UserAccountExclusiveListing,
} from '@generated/search-bff';

import { panic } from './panic';

export type GenericSearchListing = SearchListing | SearchRestrictedListing | SearchUserAccountExclusiveListing;

export type GenericExposeListing = Listing | RestrictedListing | UserAccountExclusiveListing;

export const getSearchListingResultId = (result: SearchListingResult): string => {
  return result.listing?.id ?? result.restricted?.id ?? result.userAccountExclusive?.id ?? panic('SearchListingResult has no id');
};

export const isSearchListingResultFull = (
  result: SearchListingResult,
): result is { listing: SearchListing; restricted?: never; userAccountExclusive?: never } => result.listing != null;

export const isSearchListingResultRestricted = (
  result: SearchListingResult,
): result is { listing?: never; restricted: SearchRestrictedListing; userAccountExclusive?: never } => result.restricted != null;

export const isSearchListingResultUserAccountExclusive = (
  result: SearchListingResult,
): result is { listing?: never; restricted?: never; userAccountExclusive: SearchUserAccountExclusiveListing } =>
  result.userAccountExclusive != null;

export const mapSearchListingResults = (results: SearchListingResult[]): SearchListing[] =>
  results.filter((result) => isSearchListingResultFull(result)).map((result) => result.listing);

export const isFullListing = (listing: GenericExposeListing | GenericSearchListing): listing is Listing & SearchListing =>
  'isDevelopmentProject' in listing;

export const isRestrictedListing = (
  listing: GenericExposeListing | GenericSearchListing,
): listing is RestrictedListing & SearchRestrictedListing => 'privacyLevel' in listing && listing.privacyLevel === PrivacyLevel.RESTRICTED;

export const isUserAccountExclusiveListing = (
  listing: GenericExposeListing | GenericSearchListing,
): listing is UserAccountExclusiveListing & SearchUserAccountExclusiveListing =>
  'isUserAccountExclusive' in listing && listing.isUserAccountExclusive === true;
